import React from 'react';
import Icon from '@ant-design/icons';

const ChevronLeftSVG = () => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={true}
  >
    <title>Icon / Chevron-left</title>
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g id="Icon-/-Chevron-left" stroke="currentColor">
        <polyline
          id="Path"
          transform="translate(8.000000, 8.000000) scale(1, -1) rotate(90.000000) translate(-8.000000, -8.000000) "
          points="1 4.5 8 11.5 15 4.5"
        />
      </g>
    </g>
  </svg>
);

export const JChevronLeft: React.FC<any> = (props) => {
  return <Icon component={ChevronLeftSVG} {...props}  aria-hidden={true}/>;
};
